<!-- <app-main-carousel [slides]="slides"></app-main-carousel> -->
<!-- <app-banners [banners]="banners"></app-banners> -->
<div>
    <div>
        <div class="container" fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center"
            ngClass.xs="mobileContainer">
            <div fxFlex="30%" fxFlex.xs="100%" fxFlex.gt-sm="33%" *ngFor="let slide of slides">
                <mat-card (mouseover)="hover=true" (mouseleave)="hover=false" class="mat-elevation-z4">

                    <img mat-card-image src="{{slide.image}}">
                    <mat-card-content style="text-align: center;">
                        <mat-card-title>
                            <a style="text-decoration:none;" [routerLink]="['/products']" class="title">{{slide.title}}
                            </a>
                        </mat-card-title>
                        <p>
                            {{slide.desc}}
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
    <!-- <div fxLayout="row wrap" class="info-bar">
        <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50">
            <mat-card class="light-block" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="mat-icon-xlg text-muted m-0">card_giftcard</mat-icon>
                <div class="content">
                    <p>BONUS PLUS</p>
                    <span class="text-muted m-0">Make fun of shopping and collect bonuses</span>
                </div>
            </mat-card>
        </div>
        <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50">
            <mat-card class="light-block" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="mat-icon-xlg text-muted m-0">local_shipping</mat-icon>
                <div class="content">
                    <p>FREE SHIPPING</p>
                    <span class="text-muted m-0">Free shipping on all orders over $99</span>
                </div>
            </mat-card>
        </div>
        <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50">
            <mat-card class="light-block" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="mat-icon-xlg text-muted m-0">monetization_on</mat-icon>
                <div class="content">
                    <p>MONEY BACK GUARANTEE</p>
                    <span class="text-muted m-0">30 Days money return guarantee</span>
                </div>
            </mat-card>
        </div>
        <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50">
            <mat-card class="light-block" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="mat-icon-xlg text-muted m-0">history</mat-icon>
                <div class="content">
                    <p>ONLINE SUPPORT 24/7</p>
                    <span class="text-muted m-0">Call us: (+100) 123 456 7890</span>
                </div>
            </mat-card>
        </div>
    </div> -->
    <div class="products-tabs">
        <mat-tab-group mat-stretch-tabs (selectedTabChange)="onLinkClick($event)">
            <mat-tab label="Featured">
                <app-products-carousel [products]="featuredProducts"></app-products-carousel>
            </mat-tab>
            <!-- <mat-tab label="On Sale">
           <app-products-carousel [products]="onSaleProducts"></app-products-carousel>
        </mat-tab>
        <mat-tab label="Top Rated">
            <app-products-carousel [products]="topRatedProducts"></app-products-carousel>
        </mat-tab>
        <mat-tab label="New Arrivals">
            <app-products-carousel [products]="newArrivalsProducts"></app-products-carousel>
        </mat-tab> -->
        </mat-tab-group>
    </div>
    <!-- <app-brands-carousel [brands]="brands"></app-brands-carousel> -->
</div>